import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const entityDialogHostStyleId = 'wb-v2-entity-dialog-host-theme';

export const entityDialogHostBridgeStyles = {
  'entity-dialog-host': {
    '--local-entity-dialog-z-index': '1000',
    '--local-entity-dialog-pseudo-inset': '10px',
    '--local-entity-dialog-sized-inset': tokens.spacing.sixXl,
    '--local-entity-dialog-header-height': '48px',
    '--local-entity-dialog-header-pad-x': tokens.spacing.md,
    '--local-entity-dialog-header-gap': tokens.spacing.sm,
    '--local-entity-dialog-title-size': tokens.font.size.textMdBase,
    '--local-entity-dialog-title-weight': tokens.font.weight.semibold,
    '--local-entity-dialog-title-line': tokens.lineHeight.textMd,
    '--local-entity-dialog-close-size': '24px',
    '--local-entity-dialog-radius': tokens.radius.xl,
    '--local-entity-dialog-shadow': tokens.shadow.xl,
    '--local-entity-dialog-bg': tokens.color.background.primary,
    '--local-entity-dialog-title-color': tokens.color.text.primary,
    '--local-entity-dialog-close-color': tokens.color.text.secondary,
    '--local-entity-dialog-close-hover': tokens.color.text.primary,
    '--local-entity-dialog-header-border': tokens.color.border.secondary,
    '--local-entity-dialog-status-color': tokens.color.text.secondary,
    '--local-entity-dialog-status-size': tokens.font.size.textSm,
    '--local-entity-dialog-status-gap': tokens.spacing.sm,
    '--local-entity-dialog-backdrop': tokens.color.background.overlay,
  },
};
